<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1231_3855)">
<path d="M12.5 3.5L3.5 12.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.5 12.5L3.5 3.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_1231_3855">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
